export default __webpack_public_path__ + "static/media/de_passie.412d7124.svg";